import { TextField as MaterialTextField } from "@material-ui/core";
import React, {
  ChangeEvent,
  ComponentProps,
  SyntheticEvent,
  useCallback,
} from "react";

export type CustomChangeEvent<T = Element> = SyntheticEvent<T> & {
  target: Omit<EventTarget & T, "value"> & {
    value: number | ""; // Casting event.target.value to a number
  };
};

export type NumberFieldProps = Omit<
  ComponentProps<typeof MaterialTextField>,
  "onChange"
> & {
  onChange?: (e: CustomChangeEvent<HTMLInputElement>) => void;
  min?: number;
  max?: number;
};

export const NumberField = React.forwardRef<HTMLInputElement, NumberFieldProps>(
  ({ min, max, onChange, ...props }, ref) => {
    const onChangeCallback = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        let value =
          e.target.value === "" ? ("" as "") : parseInt(e.target.value, 10);

        if (typeof value === "number") {
          if (min !== undefined) {
            value = Math.max(min, value);
          }

          if (max !== undefined) {
            value = Math.min(max, value);
          }
        }

        const foo = {
          ...e,
          target: {
            ...e.target,
            value:
              e.target.value === "" ? ("" as "") : parseInt(e.target.value, 10),
          },
        };

        return onChange ? onChange(foo) : undefined;
      },
      [min, max, onChange]
    );

    return (
      <MaterialTextField
        innerRef={ref}
        {...props}
        inputProps={{ type: "number", ...props.inputProps }}
        variant="outlined"
        onChange={onChangeCallback}
      />
    );
  }
);
